import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabhireforoutstationinmumbai() {



    const cardData = {

keyword: "Car Hire for Outstation in Mumbai",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Car Hire for Outstation in Mumbai for one-way trips, round trips, weekend getaways, family vacations, corporate travel, pilgrimage tours, and long-distance intercity journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup and drop across Mumbai, flexible travel plans, and safe highway driving, we ensure a smooth, comfortable, and hassle-free outstation travel experience across India.",

topPlaces: [
    {
        title: "Ajanta & Ellora Caves",
        description:
            "Ajanta and Ellora Caves in Aurangabad are UNESCO World Heritage Sites known for ancient rock-cut temples, sculptures, and historical significance. They are one of the most popular heritage road trip destinations from Mumbai."
    },
    {
        title: "Rann of Kutch",
        description:
            "The White Rann of Kutch in Gujarat is famous for its vast salt desert, cultural festivals, and stunning white landscape. It is a unique long-distance road trip destination from Mumbai."
    },
    {
        title: "Mahabaleshwar & Panchgani",
        description:
            "Mahabaleshwar and Panchgani are beautiful hill stations known for strawberry farms, viewpoints, and cool weather. They are ideal weekend getaway destinations from Mumbai."
    },
    {
        title: "Goa Beaches",
        description:
            "Goa is India’s most popular beach destination known for nightlife, water sports, and scenic beaches. It is a top long-distance travel route for leisure trips from Mumbai."
    },
    {
        title: "Shirdi & Shani Shingnapur",
        description:
            "Shirdi and Shani Shingnapur are major pilgrimage destinations in Maharashtra. Devotees frequently book outstation car hire for comfortable spiritual journeys from Mumbai."
    },
    {
        title: "Udaipur Lake City",
        description:
            "Udaipur in Rajasthan is known for its royal palaces, lakes, and heritage charm. It is a popular long-distance romantic and family travel destination from Mumbai."
    },
    {
        title: "Pune & Lavasa",
        description:
            "Pune and Lavasa offer a mix of urban lifestyle and scenic planned hill city views. They are frequently visited for business trips, leisure, and weekend travel."
    },
    {
        title: "Alibaug Coastal Escape",
        description:
            "Alibaug is a peaceful beach destination near Mumbai known for clean beaches, forts, and resorts. It is ideal for short outstation trips and weekend relaxation."
    },
    {
        title: "Nashik Wine & Temple Tour",
        description:
            "Nashik is famous for vineyards, Trimbakeshwar Jyotirlinga, and religious significance. It is a popular outstation car hire destination from Mumbai for both leisure and pilgrimage."
    },
    {
        title: "Lonavala & Khandala Hills",
        description:
            "Lonavala and Khandala are scenic hill stations known for waterfalls, valleys, and monsoon beauty. They are among the most preferred short road trips from Mumbai."
    }
],



services: [
{
name: "Car Hire for Outstation in Mumbai",
description: "Mumbai Airport Cab offers Car Hire for Outstation in Mumbai service for safe, comfortable, and reliable long-distance travel to destinations across Maharashtra and India. Whether you are planning a family vacation, business trip, weekend getaway, pilgrimage tour, or intercity travel, we provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Kia Carens, Tempo Traveller, and luxury cars. Our professional chauffeurs are experienced in highway driving, ensuring smooth journeys with proper route planning, safety, and comfort. With transparent pricing, flexible pickup and drop options, doorstep service, and 24x7 support, we make outstation car hire from Mumbai convenient, affordable, and stress-free."
},
{
name: "Mumbai Outstation Car Hire",
description: "Mumbai Outstation Car Hire service by Mumbai Airport Cab provides reliable chauffeur-driven vehicles for long-distance travel to cities like Pune, Nashik, Shirdi, Goa, Mahabaleshwar, Lonavala, Aurangabad, Kolhapur, and more. Our fleet is designed for comfort and safety with spacious seating, air-conditioning, luggage capacity, and professional drivers. We offer flexible booking options, transparent billing, and customized travel plans for families, tourists, and corporate travellers, ensuring a smooth and enjoyable outstation journey from Mumbai."
},
{
name: "Rent Car for Outstation Mumbai",
description: "Rent Car for Outstation Mumbai service is ideal for passengers looking for convenient and affordable transportation for intercity and interstate travel. Mumbai Airport Cab offers a wide range of vehicles suitable for solo travellers, families, and groups. With experienced chauffeurs, comfortable interiors, and flexible itineraries, we ensure safe and efficient travel for vacations, business trips, and pilgrimage journeys across India."
},
{
name: "Mumbai Long Distance Car Rental",
description: "Mumbai Long Distance Car Rental service provides comfortable and reliable transportation for extended journeys across states and regions. Mumbai Airport Cab offers well-maintained vehicles with professional drivers trained for highway travel. We ensure safe driving, timely pickups, luggage assistance, and smooth ride quality, making long-distance travel stress-free and comfortable for all passengers."
},
{
name: "Outstation Cab Hire Mumbai",
description: "Outstation Cab Hire Mumbai service offers flexible and dependable car rental solutions for long-distance travel needs. Mumbai Airport Cab provides sedans, SUVs, and luxury vehicles driven by professional chauffeurs for family trips, business travel, tourism, and pilgrimage journeys. We focus on safety, comfort, and affordability to ensure a seamless outstation travel experience."
},
{
name: "Mumbai Intercity Car Hire Service",
description: "Mumbai Intercity Car Hire Service provides reliable transportation between Mumbai and major cities across India. Mumbai Airport Cab ensures comfortable vehicles, experienced drivers, and flexible travel schedules for business meetings, family visits, tourism, and relocation travel. We guarantee punctual service and safe highway journeys for all intercity travel needs."
},
{
name: "Mumbai Road Trip Car Hire",
description: "Mumbai Road Trip Car Hire service is designed for scenic highway journeys, weekend drives, and leisure travel. Mumbai Airport Cab offers comfortable vehicles and professional chauffeurs who ensure smooth, enjoyable road trips to destinations like Lonavala, Goa, Mahabaleshwar, and beyond. We provide flexible itineraries and safe driving for memorable travel experiences."
},
{
name: "Mumbai Travel Car Rental",
description: "Mumbai Travel Car Rental service provides versatile transportation solutions for city travel, outstation trips, sightseeing tours, and business journeys. Mumbai Airport Cab offers a wide range of vehicles with professional drivers, ensuring comfort, reliability, and affordability for all types of travel requirements across Mumbai and India."
},
{
name: "Mumbai One Way Car Hire",
description: "Mumbai One Way Car Hire service offers cost-effective transportation for passengers who need travel from Mumbai to another city without return charges. Mumbai Airport Cab provides transparent pricing, flexible pickup and drop locations, and comfortable vehicles for business travel, relocation, and intercity journeys."
},
{
name: "Mumbai Round Trip Car Hire",
description: "Mumbai Round Trip Car Hire service provides complete return journey solutions for family vacations, business trips, pilgrimage tours, and tourism travel. Mumbai Airport Cab ensures comfortable vehicles, professional chauffeurs, and flexible travel schedules for a smooth and stress-free round trip experience."
},
{
name: "Mumbai Highway Car Hire",
description: "Mumbai Highway Car Hire service offers safe and efficient transportation for long highway routes connecting Mumbai with major cities and tourist destinations. Mumbai Airport Cab provides experienced drivers, well-maintained vehicles, and optimized travel routes for comfortable and reliable intercity travel."
},
{
name: "Mumbai Holiday Car Rental",
description: "Mumbai Holiday Car Rental service is ideal for vacation travel to beaches, hill stations, and tourist destinations across India. Mumbai Airport Cab offers customized holiday packages with comfortable vehicles, professional chauffeurs, and flexible itineraries for a relaxing and enjoyable travel experience."
},
{
name: "Mumbai Family Outstation Car Hire",
description: "Mumbai Family Outstation Car Hire service provides spacious and comfortable vehicles for family vacations, pilgrimage tours, and weekend getaways. Mumbai Airport Cab ensures safe driving, ample luggage space, air-conditioned comfort, and professional drivers for a smooth family travel experience."
},
{
name: "Mumbai Business Outstation Car Hire",
description: "Mumbai Business Outstation Car Hire service is designed for corporate travellers requiring reliable transportation for meetings, conferences, and intercity business travel. Mumbai Airport Cab offers punctual service, professional chauffeurs, and comfortable vehicles to ensure productive and stress-free business journeys."
},
{
name: "Mumbai Weekend Car Hire",
description: "Mumbai Weekend Car Hire service offers quick and convenient travel solutions for short trips and weekend getaways. Mumbai Airport Cab provides comfortable vehicles and experienced drivers for destinations like Lonavala, Khandala, Mahabaleshwar, and nearby tourist spots, ensuring a relaxing travel experience."
}
],

tableData: [
["Car Hire for Outstation in Mumbai","Mumbai Outstation Car Hire"],
["Rent Car for Outstation Mumbai","Mumbai Long Distance Car Rental"],
["Outstation Cab Hire Mumbai","Mumbai Intercity Car Hire Service"],
["Mumbai Road Trip Car Hire","Mumbai Travel Car Rental"],
["Mumbai One Way Car Hire","Mumbai Round Trip Car Hire"],
["Mumbai Highway Car Hire","Mumbai Holiday Car Rental"],
["Mumbai Family Outstation Car Hire","Mumbai Business Outstation Car Hire"],
["Mumbai Weekend Car Hire","Mumbai Outstation Travel Cab"]
],






whychoose: [
    {
        WhyChooseheading: "Reliable Car Hire for Outstation in Mumbai",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable car hire services for outstation travel from Mumbai to popular destinations across Maharashtra, Gujarat, Goa, Karnataka, Rajasthan, and other states."
    },
    {
        WhyChooseheading: "Comfortable Long-Distance Travel Experience",
        WhyChoosedescription: "Our outstation vehicles are maintained for long journeys, ensuring comfortable seating, smooth rides, and a hassle-free travel experience."
    },
    {
        WhyChooseheading: "Perfect for Family Trips and Business Travel",
        WhyChoosedescription: "Whether you are planning a vacation, corporate meeting, pilgrimage tour, wedding event, or family visit, we offer suitable transportation solutions."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Choices",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles based on travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Packages",
        WhyChoosedescription: "We provide flexible booking options including one-way travel, round trips, multi-city tours, and customized outstation itineraries."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Mumbai",
        WhyChoosedescription: "Pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Dombivli, Kalyan, Borivali, Bandra, Dadar, Andheri, Powai, and nearby locations."
    },
    {
        WhyChooseheading: "Professional Drivers for Interstate Travel",
        WhyChoosedescription: "Our experienced chauffeurs are familiar with major highways, tourist destinations, and interstate travel routes, ensuring safe and timely journeys."
    },
    {
        WhyChooseheading: "Ideal for Families, Tourists, and Corporate Clients",
        WhyChoosedescription: "From solo travelers and families to corporate teams and large groups, we provide suitable outstation transportation for every requirement."
    }
]
};

const faqData = [
    {
        question: "What is Car Hire for Outstation in Mumbai?",
        answer: "Car Hire for Outstation allows customers to rent vehicles with drivers for travel from Mumbai to destinations outside the city."
    },
    {
        question: "Which destinations can I travel to from Mumbai?",
        answer: "Customers can book vehicles for Pune, Nashik, Shirdi, Mahabaleshwar, Goa, Ahmedabad, Jaipur, Bangalore, Indore, Lonavala, and many other destinations."
    },
    {
        question: "Can I book a one-way outstation car?",
        answer: "Yes, one-way car hire services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicles are available for outstation travel?",
        answer: "Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and luxury vehicles are available."
    },
    {
        question: "Can I hire a vehicle for a multi-day trip?",
        answer: "Yes, customers can book vehicles for multi-day tours, vacations, business visits, and pilgrimage journeys."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, corporate outings, religious tours, and educational trips."
    },
    {
        question: "Can I customize my travel itinerary?",
        answer: "Yes, customers can include multiple cities, sightseeing locations, religious destinations, and personal stops according to their travel plans."
    },
    {
        question: "Is airport pickup available for outstation travel?",
        answer: "Yes, customers can start their outstation journey directly from Mumbai Airport or any location within Mumbai."
    },
    {
        question: "Should I book in advance for outstation travel?",
        answer: "Yes, advance booking is recommended to secure your preferred vehicle and ensure smooth travel planning."
    },
    {
        question: "How can I book Car Hire for Outstation in Mumbai?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rajeev Kulkarni",
        feedback:
            "We hired an Innova Crysta for a week-long family vacation and the experience was exceptional. The vehicle was comfortable, and the driver handled the entire journey professionally.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Neha Sharma",
        feedback:
            "Our outstation trip from Mumbai was smooth and stress-free. The vehicle was clean, spacious, and perfectly suited for long-distance travel with family.",
        rating: 5
    }
];








































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Car Hire for Outstation in Mumbai",
"image": "https://www.mumbaiairportcabs.com/assets/images/car-hire-for-outstation-mumbai.jpg",
"description": "Book car hire for outstation travel in Mumbai for long-distance trips, intercity journeys, weekend getaways, and road trips. Mumbai Airport Cabs offers reliable chauffeur-driven cars with flexible one-way and round-trip options, professional drivers, and affordable pricing.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/car-hire-for-outstation-in-mumbai"
}
};








    return (
        <div>


<Helmet>
  <title>Car Hire for Outstation in Mumbai | Long Distance Cab | +91 9545731161</title>

<meta
 name="description"
 content="Book car hire for outstation in Mumbai for long-distance travel, intercity trips, and road journeys. Affordable chauffeur-driven cars with one-way and round-trip options."
/>

<meta
 name="keywords"
 content="car hire for outstation in mumbai, mumbai outstation car hire, rent car for outstation mumbai, mumbai long distance car rental, outstation cab hire mumbai, mumbai intercity car hire service, mumbai road trip car hire, mumbai travel car rental, mumbai one way car hire"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/120.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabhireforoutstationinmumbai;